import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import ArtifactShellRenderer from '../components/common/ArtifactShellRenderer';
import DevicePreviewFrame from '../components/common/DevicePreviewFrame';

/**
 * DesignPreview — Clean full-screen preview of wireframes, designs, or design-system.
 * No sidebar, no chat, no header.
 * Has the same device toggle bar (Desktop / Tablet / Mobile) as the split view.
 * Route: /projects/:projectId/preview/:taskType
 */
const DesignPreview = () => {
  const { projectId, taskType } = useParams();
  const [device, setDevice] = useState('desktop');
  const [currentPageId, setCurrentPageId] = useState(null);

  return (
    <Box sx={{
      width: '100vw',
      height: '100vh',
      overflow: 'hidden',
      bgcolor: '#f5f6f7',
      display: 'flex',
      flexDirection: 'column',
    }}>
      <DevicePreviewFrame device={device} onDeviceChange={setDevice}>
        <ArtifactShellRenderer
          projectId={projectId}
          taskType={taskType || 'wireframes'}
          currentPageId={currentPageId}
          onPageChange={(pageId) => setCurrentPageId(pageId)}
        />
      </DevicePreviewFrame>
    </Box>
  );
};

export default DesignPreview;
